import React from 'react';

const PremiumHeader = ({ userData }) => {
  return (
    <div className="relative pt-16 pb-12 px-6 overflow-hidden">
      
      {/* --- Ambient Background Decor --- */}
      {/* This creates a soft, luxury glow behind the content */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full -z-10 opacity-40">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-amber-500/20 rounded-full blur-[100px]" />
        <div className="absolute top-10 right-1/4 w-64 h-64 bg-orange-600/10 rounded-full blur-[100px]" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative">
        
        {/* --- Logo Presentation --- */}
        {userData?.logo && (
          <div className="relative inline-block mb-8 group">
            {/* Subtle rotating border/glow effect */}
            <div className="absolute -inset-4 bg-gradient-to-tr from-amber-500/20 to-transparent rounded-full blur-xl group-hover:opacity-100 transition-opacity duration-700" />
            
            <div className="relative bg-white/50 p-2 rounded-2xl border border-white/20 shadow-2xl">
              <img 
                src={userData?.logo} 
                className="w-auto h-24 object-contain rounded-2xl drop-shadow-md" 
                alt="business logo" 
              />
            </div>

            {/* "Live Menu" Status Badge */}
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-1.5 bg-zinc-900 px-2 py-1 rounded-full border border-white/10 shadow-lg">
              <span className="relative flex h-2 w-2">
                <span className=" absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
              </span>
              <span className="text-[8px] font-black text-white uppercase tracking-[0.2em]">catalog</span>
              <span className="relative flex h-2 w-2">
                <span className=" absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
              </span>
            </div>
          </div>
        )}

        {/* --- Business Name --- */}
        <div className="space-y-2 mb-6">
          <h1 className="text-4xl sm:text-6xl font-black text-zinc-900 tracking-tighter leading-none">
            {userData?.businessName}
          </h1>
          {/* A more elegant divider: A line with a central diamond */}
          <div className="flex items-center justify-center gap-4 py-2">
            <div className="h-[1px] w-12 bg-gradient-to-r from-transparent to-amber-400/50" />
            <div className="w-1.5 h-1.5 rotate-45 bg-amber-500 shadow-[0_0_10px_rgba(245,158,11,0.5)]" />
            <div className="h-[1px] w-12 bg-gradient-to-l from-transparent to-amber-400/50" />
          </div>
        </div>

        {/* --- Welcome Message --- */}
        <div className="relative inline-block">
          <p className="text-zinc-500 text-base md:text-lg max-w-md mx-auto leading-relaxed font-medium">
  Browse our exclusive collection of 
  <span className="text-zinc-900 mx-1">carefully selected offerings</span>
</p>

          
          {/* Subtle Instruction Helper */}
          <div className="mt-8 flex items-center justify-center gap-3">
             <div className="flex -space-x-2">
                {[1,2,3].map(i => (
                  <div key={i} className="w-6 h-6 rounded-full border-2 border-white bg-zinc-100 flex items-center justify-center overflow-hidden">
                    <div className={`w-full h-full bg-amber-${i+2}00/20`} />
                  </div>
                ))}
             </div>
             <p className="text-[11px] font-bold text-zinc-400 uppercase tracking-widest">
                Scroll to explore
             </p>
          </div>
        </div>
      </div>

      {/* Decorative side accent (optional) */}
      <div className="absolute top-20 left-0 w-32 h-[1px] bg-gradient-to-r from-amber-200/50 to-transparent hidden lg:block" />
      <div className="absolute top-20 right-0 w-32 h-[1px] bg-gradient-to-l from-amber-200/50 to-transparent hidden lg:block" />
    </div>
  );
};

export default PremiumHeader;